// extracted by mini-css-extract-plugin
module.exports = {"textIntro__body":"_P","textIntro":"_Q","textIntro__pageLink":"_R"};